module.exports = __webpack_public_path__ + "img/google.9b224c98.png";